import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CondVariante } from '../../modelos/CondVariante';
import { Material } from '../../../portfolio/interfaces/material.interface';
import { MaterialsService } from '../../../portfolio/services/materials.service';

@Component({
  selector: 'app-modal-variantes',
  templateUrl: './modal-variantes.component.html',
  styleUrls: ['./modal-variantes.component.css']
})
export class ModalVariantesComponent implements OnInit, OnChanges {

  @Input() idPromo: string;
  @Input() bonificador: any;
  @Input() open: boolean = false;
  @Output() close = new EventEmitter<void>();

  public variantes: CondVariante[] = [];
  public loading: boolean = false;
  public selectedMaterialVar?: Material;
  public materialTitle: string = '';

  // Buscador de Materiales Integrado
  public mostrarBuscador: boolean = false;
  public buscandoMateriales: boolean = false;
  public textoBusqueda: string = '';
  public opcionBusqueda: string = 'dscaMaterial';
  public materialesEncontrados: Material[] = [];
  public paginaActual: number = 0;
  public totalItems: number = 0;
  public pageSize: number = 10;

  public opcionesFiltro = [
    { label: 'Descripción', value: 'dscaMaterial' },
    { label: 'Código Material', value: 'idMaterial' }
  ];

  constructor(
    private readonly promocionesService: PromocionesService,
    private readonly materialsService: MaterialsService,
    private readonly toastrService: ToastrService,
    private readonly _util: UtilsService
  ) {}

  ngOnInit(): void {
    if (this.bonificador && this.idPromo) {
      this.cargarVariantes();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const isFirst = (changes['bonificador'] && changes['bonificador'].isFirstChange()) ||
                    (changes['idPromo'] && changes['idPromo'].isFirstChange());
    if (!isFirst && (changes['bonificador'] || changes['idPromo']) && this.bonificador && this.idPromo) {
      this.selectedMaterialVar = undefined;
      this.materialTitle = '';
      this.mostrarBuscador = false;
      this.materialesEncontrados = [];
      this.cargarVariantes();
    }
  }

  public toggleBuscador(): void {
    this.mostrarBuscador = !this.mostrarBuscador;
    if (this.mostrarBuscador && this.materialesEncontrados.length === 0) {
      this.buscarMateriales(0);
    }
  }

  public buscarMateriales(page: number = 0): void {
    this.paginaActual = page;
    this.buscandoMateriales = true;

    const queryParams: any = {
      page: this.paginaActual,
      pageSize: this.pageSize,
      statusMaterial: 'true'
    };

    if (this.textoBusqueda && this.textoBusqueda.trim() !== '') {
      queryParams[this.opcionBusqueda] = this.textoBusqueda.trim();
    }

    this.materialsService.queryParams = queryParams;
    this.materialsService.findBy().subscribe({
      next: (res) => {
        if (res && res.respuesta) {
          this.materialesEncontrados = res.respuesta;
          this.totalItems = res.pagination ? res.pagination.totalItems : res.respuesta.length;
        } else {
          this.materialesEncontrados = [];
          this.totalItems = 0;
        }
        this.buscandoMateriales = false;
      },
      error: () => {
        this.materialesEncontrados = [];
        this.totalItems = 0;
        this.buscandoMateriales = false;
      }
    });
  }

  public seleccionarMaterial(mat: Material): void {
    if (!mat) return;
    if (`${mat.idMaterial}` === `${this.bonificador?.id_material}`) {
      this.toastrService.warning('El material variante no puede ser idéntico al material principal del combo.', 'Advertencia');
      return;
    }
    this.selectedMaterialVar = mat;
    this.materialTitle = `${mat.idMaterial} - ${mat.dscaMaterial || ''}`;
    this.mostrarBuscador = false;
  }

  public cargarVariantes(): void {
    if (!this.bonificador || !this.idPromo) return;
    this.loading = true;
    const idMaterial = this.bonificador.id_material;
    const idUnidad = this.bonificador.id_unidad || 'UN';

    this.promocionesService.getVariantesPorMaterial(this.idPromo, idMaterial, idUnidad).subscribe({
      next: (resp) => {
        if (resp && Array.isArray(resp)) {
          this.variantes = resp;
        } else if (resp && resp.respuesta && Array.isArray(resp.respuesta)) {
          this.variantes = resp.respuesta;
        } else {
          this.variantes = [];
        }
        this.loading = false;
      },
      error: () => {
        this.variantes = [];
        this.loading = false;
      }
    });
  }

  public setMaterialVariante(material: Material): void {
    if (!material) return;
    if (`${material.idMaterial}` === `${this.bonificador?.id_material}`) {
      this.toastrService.warning('El material variante no puede ser idéntico al material principal del combo.', 'Advertencia');
      return;
    }
    this.selectedMaterialVar = material;
    this.materialTitle = `${material.idMaterial} - ${material.dscaMaterial || ''}`;
  }

  public agregarVariante(): void {
    if (!this.selectedMaterialVar) {
      this.toastrService.warning('Por favor seleccione un material variante.', 'Campo requerido');
      return;
    }

    const idMaterialVar = `${this.selectedMaterialVar.idMaterial}`;
    const existe = this.variantes.some((v) => `${v.id_material_var}` === idMaterialVar);
    if (existe) {
      this.toastrService.warning('Este material ya está registrado como variante de este bonificador.', 'Registro duplicado');
      return;
    }

    const payload: CondVariante = {
      id_promo: this.idPromo,
      id_material: `${this.bonificador.id_material}`,
      id_unidad: this.bonificador.id_unidad || 'UN',
      id_material_var: idMaterialVar
    };

    this.loading = true;
    this.promocionesService.crearVariante(payload).subscribe({
      next: (resp) => {
        this.toastrService.success(resp?.mensaje || 'Variante agregada correctamente', 'Éxito');
        this.selectedMaterialVar = undefined;
        this.materialTitle = '';
        this.cargarVariantes();
      },
      error: (err) => {
        this.loading = false;
        this.toastrService.error(err?.error?.mensaje || 'Error al guardar la variante', 'Error');
      }
    });
  }

  public eliminarVariante(variante: CondVariante): void {
    this._util.confirmarSincronoPromesa({
      title: 'Eliminar Variante',
      text: `¿Está seguro de eliminar la variante ${variante.id_material_var} - ${variante.name_material_var || ''}?`,
      action: 'Eliminar',
      funcion: this.promocionesService.eliminarVariante(
        variante.id_promo,
        variante.id_material,
        variante.id_unidad,
        variante.id_material_var
      )
    }).then(() => {
      this.toastrService.success('Variante eliminada correctamente', 'Éxito');
      this.cargarVariantes();
    });
  }

  public cerrarModal(): void {
    this.selectedMaterialVar = undefined;
    this.materialTitle = '';
    this.mostrarBuscador = false;
    this.close.emit();
  }
}
